import React, {useEffect, useState} from "react";
import { tableUseStyle } from "../../etc/tableusestyle";
import { DataGridPremium } from "@mui/x-data-grid-premium";


const WinterRegister : React.FC<any> = (props) => {

    const classes = tableUseStyle();
    const [columns, setColumns] = useState([
        {
            field : "id",
            headerName : "ID",
            width : 80
        },
        {
            field : "kind",
            headerName : "종류",
            width : 120
        },
        {
            field : "date",
            headerName : "등록 기간",
            width : 120
        },
    ])
    return (
        <div style={{
            width: "96%"
        }}>
            <div style={{
                fontFamily: "Apple_B",
                marginTop: "50px",
                fontSize: "18px",
                display: "flex",
                alignItems: "center",
            }}>
                <div style={{
                    marginRight: "18px"
                }}>
                    윈터 스쿨 등록 관리
                </div>
            </div>
             <div className={classes.root} style={{ height: "500px", width: "100%" }}>
             </div>

        </div>
    )
}

export default WinterRegister;